import { useState, useEffect, useCallback } from "react"
import { Link } from "react-router-dom"
import {
    colorCode,
    safetyPercentage,
    riskProfile,
    consoleLog,
} from "../utilities/helpers"
import { getReports } from "../services/chaperonConnector"
import { SESSIONSTORAGE_REPORTS } from "../const/storage"

export default function ReportCard() {
    const [report, setReport] = useState({})

    const loadReports = useCallback(async () => {
        // TODO: Load from local storage if exists
        let reports = JSON.parse(sessionStorage.getItem(SESSIONSTORAGE_REPORTS))
        if (reports?.length > 0) {
            consoleLog("Loaded reports from session storage.", reports)
        } else {
            reports = await getReports()

            sessionStorage.setItem(
                SESSIONSTORAGE_REPORTS,
                JSON.stringify(reports)
            )
        }
        setReport(reports[0])
    }, [])

    useEffect(() => {
        loadReports()
    }, [loadReports])

    return (
        <div className="card h-100">
            <img
                src={`${report?.image}`}
                className="card-img-top"
                alt={`${report?.title}`}
                title={`${report?.title}`}
            />
            <div
                className="progress"
                style={{ height: "20px", borderRadius: "0px" }}
            >
                <div
                    className={`progress-bar bg-${colorCode(
                        safetyPercentage(report?.overall_safety)
                    )}`}
                    role="progressbar"
                    aria-valuenow={
                        100 - safetyPercentage(report?.overall_safety)
                    }
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                        width: `${safetyPercentage(report?.overall_safety)}%`,
                    }}
                >
                    <b style={{ textTransform: "uppercase" }}>
                        {riskProfile(safetyPercentage(report?.overall_safety))}
                    </b>
                </div>
            </div>

            <div className="card-body">
                <h5 className="card-title pb-2" title={report?.title}>
                    "
                    {report?.title?.length > 100
                        ? `${report?.title.substring(0, 100)}...`
                        : report?.title}
                    "
                </h5>

                <span className="badge bg-light text-secondary">
                    <kbd
                        className={`me-2 bg-${colorCode(
                            safetyPercentage(report?.overall_safety)
                        )}`}
                        title="Reporter"
                    >
                        {report?.reporter_id ? (
                            report.reporter_id
                        ) : (
                            <span>{report?.name}</span>
                        )}
                    </kbd>
                    {report?.reporter_id ? (
                        <div>
                            <i
                                className="bi bi-facebook pe-2"
                                title="Facebook"
                            ></i>
                            <i
                                className="bi bi-instagram pe-2"
                                title="Instagram"
                            ></i>
                            <i
                                className="bi bi-linkedin pe-2"
                                title="LinkedIn"
                            ></i>
                            <i
                                className="bi bi-messenger pe-2"
                                title="Messenger"
                            ></i>
                            <i className="bi bi-reddit pe-2" title="Reddit"></i>
                            <i
                                className="bi bi-twitter-x pe-2"
                                title="Twitter"
                            ></i>
                            <i
                                className="bi bi-youtube pe-2"
                                title="YouTube"
                            ></i>
                            <i
                                className="bi bi-whatsapp pe-2"
                                title="WhatsApp"
                            ></i>
                        </div>
                    ) : (
                        <span></span>
                    )}
                    <br></br>
                </span>

                <p className="card-text text-start pt-3">
                    {report?.review?.length > 200
                        ? `${report?.review.substring(0, 200)}...`
                        : report?.review}
                </p>

                <dialog
                    id="reportDetails"
                    className="ps-4 pe-4"
                    style={{ width: "50%" }}
                >
                    <img
                        src={`${report?.image}`}
                        className="card-img-top"
                        alt={`${report?.title}`}
                        title={`${report?.title}`}
                    />
                    <h5 className="card-title pt-3 pb-2" title={report?.title}>
                        "
                        {report?.title?.length > 100
                            ? `${report?.title.substring(0, 100)}...`
                            : report?.title}
                        "
                    </h5>
                    <span className="badge bg-light text-secondary">
                        <kbd
                            className={`me-2 bg-${colorCode(
                                safetyPercentage(report?.overall_safety)
                            )}`}
                            title="Reporter"
                        >
                            {report?.reporter_id ? (
                                report.reporter_id
                            ) : (
                                <span>{report?.name}</span>
                            )}
                        </kbd>
                        {report?.reporter_id ? (
                            <div>
                                <i
                                    className="bi bi-facebook pe-2"
                                    title="Facebook"
                                ></i>
                                <i
                                    className="bi bi-instagram pe-2"
                                    title="Instagram"
                                ></i>
                                <i
                                    className="bi bi-linkedin pe-2"
                                    title="LinkedIn"
                                ></i>
                                <i
                                    className="bi bi-messenger pe-2"
                                    title="Messenger"
                                ></i>
                                <i
                                    className="bi bi-reddit pe-2"
                                    title="Reddit"
                                ></i>
                                <i
                                    className="bi bi-twitter-x pe-2"
                                    title="Twitter"
                                ></i>
                                <i
                                    className="bi bi-youtube pe-2"
                                    title="YouTube"
                                ></i>
                                <i
                                    className="bi bi-whatsapp pe-2"
                                    title="WhatsApp"
                                ></i>
                            </div>
                        ) : (
                            <span></span>
                        )}
                        <br></br>
                    </span>

                    <p className="card-text text-start pt-3">
                        {report?.review}
                    </p>
                    <hr className="mt-4 mb-4"></hr>
                    <button
                        className="btn btn-outline-secondary"
                        autoFocus
                        onClick={() => {
                            const reportDialog =
                                document.getElementById("reportDetails")
                            reportDialog.close()
                        }}
                    >
                        Close
                    </button>
                </dialog>
                <div className="d-flex justify-content-center flex-row ">
                    <div>
                        <button
                            id="reportReadMore"
                            className="btn btn-outline-secondary btn-sm mt-3"
                            onClick={() => {
                                const reportDialog =
                                    document.getElementById("reportDetails")
                                reportDialog.showModal()
                            }}
                        >
                            Read more
                        </button>
                    </div>
                    <div className="ms-2">
                        <Link to={`/analysis/${report.entity_id}`}>
                            <button className="btn btn-outline-secondary btn-sm mt-3">
                                Score card
                            </button>
                        </Link>
                    </div>
                </div>
            </div>

            <div className="card-footer">
                <small className="text-body-secondary">
                    <em>
                        {new Date(report?.updated_at).toLocaleDateString(
                            "en-US",
                            {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                            }
                        )}
                    </em>
                </small>
            </div>
        </div>
    )
}
